export const routeSectionSlugs = {
  "start-here": {
    "en": "start-here",
    "es": "comienza-aqui",
    "nl": "begin-hier",
    "pap": "kuminsa-aki"
  },
  "programs": {
    "en": "programs",
    "es": "programas",
    "nl": "programmas",
    "pap": "programanan"
  },
  "media": {
    "en": "media",
    "es": "medios",
    "nl": "media",
    "pap": "media"
  },
  "episodes": {
    "en": "episodes",
    "es": "episodios",
    "nl": "afleveringen",
    "pap": "episodionan"
  },
  "courses": {
    "en": "courses",
    "es": "cursos",
    "nl": "cursussen",
    "pap": "kursonan"
  },
  "events": {
    "en": "events",
    "es": "eventos",
    "nl": "evenementen",
    "pap": "eventonan"
  },
  "articles": {
    "en": "articles",
    "es": "articulos",
    "nl": "artikelen",
    "pap": "artikulonan"
  },
  "library": {
    "en": "library",
    "es": "biblioteca",
    "nl": "bibliotheek",
    "pap": "biblioteka"
  },
  "downloads": {
    "en": "downloads",
    "es": "descargas",
    "nl": "downloads",
    "pap": "downloadnan"
  },
  "about": {
    "en": "about",
    "es": "acerca-de",
    "nl": "over",
    "pap": "tokante"
  },
  "donate": {
    "en": "donate",
    "es": "donar",
    "nl": "doneer",
    "pap": "dona"
  },
  "policy": {
    "en": "policy",
    "es": "politica",
    "nl": "beleid",
    "pap": "politika"
  },
  "terms": {
    "en": "terms",
    "es": "terminos",
    "nl": "voorwaarden",
    "pap": "terminonan"
  },
  "accreditation-statement": {
    "en": "accreditation-statement",
    "es": "declaracion-de-acreditacion",
    "nl": "accreditatieverklaring",
    "pap": "declarashon-di-akreditashon"
  },
  "code-of-moral-conduct": {
    "en": "code-of-moral-conduct",
    "es": "codigo-de-conducta-moral",
    "nl": "code-van-moreel-gedrag",
    "pap": "kodigo-di-kondukta-moral"
  }
};

export const navigation = [
  {
    "key": "start-here",
    "type": "route",
    "label": {
      "en": "Start Here",
      "es": "Comienza Aquí",
      "nl": "Begin Hier",
      "pap": "Kuminsa Aki"
    }
  },
  {
    "key": "programs",
    "type": "route",
    "label": {
      "en": "Podcasts",
      "es": "Podcasts",
      "nl": "Podcasts",
      "pap": "Podcasts"
    }
  },
  {
    "key": "media",
    "type": "route",
    "label": {
      "en": "Videos",
      "es": "Videos",
      "nl": "Video's",
      "pap": "Videos"
    }
  },
  {
    "key": "courses",
    "type": "route",
    "label": {
      "en": "Courses",
      "es": "Cursos",
      "nl": "Cursussen",
      "pap": "Kursonan"
    }
  },
  {
    "key": "events",
    "type": "route",
    "label": {
      "en": "Events",
      "es": "Eventos",
      "nl": "Evenementen",
      "pap": "Eventonan"
    }
  },
  {
    "key": "articles",
    "type": "route",
    "label": {
      "en": "Articles",
      "es": "Artículos",
      "nl": "Artikelen",
      "pap": "Artikulonan"
    }
  },
  {
    "key": "library",
    "type": "route",
    "label": {
      "en": "Library",
      "es": "Biblioteca",
      "nl": "Bibliotheek",
      "pap": "Biblioteka"
    }
  },
  {
    "key": "downloads",
    "type": "route",
    "label": {
      "en": "Downloads",
      "es": "Descargas",
      "nl": "Downloads",
      "pap": "Downloadnan"
    }
  },
  {
    "key": "about",
    "type": "route",
    "label": {
      "en": "About",
      "es": "Acerca de",
      "nl": "Over",
      "pap": "Tokante"
    }
  },
  {
    "key": "donate",
    "type": "route",
    "label": {
      "en": "Donate",
      "es": "Donar",
      "nl": "Doneer",
      "pap": "Dona"
    }
  }
];

export const footerTrustLinks = [
  {
    "key": "policy",
    "type": "route",
    "label": {
      "en": "Policy",
      "es": "Política",
      "nl": "Beleid",
      "pap": "Politika"
    }
  },
  {
    "key": "terms",
    "type": "route",
    "label": {
      "en": "Terms",
      "es": "Términos",
      "nl": "Voorwaarden",
      "pap": "Terminonan"
    }
  }
];
